import { Link } from "react-router-dom";
import { ArrowRight, Gauge, Eye, Users, KeyRound, CreditCard } from "lucide-react";
import { TRUST_ITEMS, TECH_CAPABILITIES } from "../data/content";

const ICONS = { speed: Gauge, transparency: Eye, live: Users, ownership: KeyRound, prepaid: CreditCard };

const POST_LAUNCH = ["Maintenance", "Feature development", "Bug fixes", "Hosting", "Monitoring", "Security updates", "Application enhancements"];

export default function About() {
  return (
    <div className="pt-32 lg:pt-40 pb-24" data-testid="about-page">
      <div className="container-x">
        <p className="section-label">ABOUT BUILT2LAST.LIVE</p>
        <h1 className="mt-5 font-heading text-5xl sm:text-6xl font-black tracking-tight text-white max-w-4xl">
          WE SELL <span className="text-flame">SPEED</span> — WITH REAL ENGINEERING UNDERNEATH.
        </h1>
        <p className="mt-8 text-slate-300 max-w-3xl leading-relaxed text-base sm:text-lg">
          Built2Last.live is a rapid application development company. We combine experienced software professionals
          with modern AI-assisted/vibe-coding development workflows to dramatically reduce development time — for SMEs,
          startups, founders, enterprises and large corporates.
        </p>
        <p className="mt-5 text-slate-400 max-w-3xl leading-relaxed">
          We are not an outsourcing agency and not a staffing company. Through Rush Hour, clients can participate in
          the actual software build in real time — and every engagement ends with a handover: your software, your code,
          your credentials.
        </p>
        <p className="mt-8 font-heading text-xl sm:text-2xl font-bold text-white">
          YOU DESCRIBE IT. WE BUILD IT. <span className="text-flame">YOU OWN IT.</span>
        </p>

        <div className="mt-20">
          <p className="section-label">WHY BUILT2LAST?</p>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {TRUST_ITEMS.map((t) => {
              const Icon = ICONS[t.key];
              return (
                <div key={t.key} data-testid={`trust-${t.key}`} className="rounded-2xl border border-white/10 bg-navy-800 p-7 card-lift">
                  <Icon className="w-6 h-6 text-flame" />
                  <h3 className="mt-5 font-heading font-bold text-sm tracking-wide text-white">{t.title}</h3>
                  <p className="mt-3 text-xs text-slate-400 leading-relaxed">{t.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-20 rounded-2xl border border-white/10 bg-navy-800 p-8 sm:p-12">
          <p className="section-label">TECHNOLOGY</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
            MODERN DEVELOPMENT. <span className="text-flame">REAL ENGINEERING.</span>
          </h2>
          <p className="mt-4 text-sm text-slate-400 max-w-2xl leading-relaxed">
            We combine experienced software engineering, product thinking and AI-assisted/vibe-coding workflows to
            accelerate application development.
          </p>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {TECH_CAPABILITIES.map((t) => (
              <span key={t} className="rounded-full border border-white/10 bg-navy-900/60 px-4 py-2 text-xs text-slate-300">{t}</span>
            ))}
          </div>
        </div>

        <div className="mt-20">
          <p className="section-label">POST-LAUNCH SERVICES</p>
          <h2 className="mt-4 font-heading text-3xl font-bold tracking-tight text-white">AFTER THE HANDOVER.</h2>
          <p className="mt-4 text-sm text-slate-400 max-w-2xl">
            Optional services available separately — not included in the base project unless purchased.
          </p>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {POST_LAUNCH.map((s) => (
              <span key={s} className="rounded-full border border-white/10 bg-navy-800 px-4 py-2 text-xs text-slate-300">{s}</span>
            ))}
          </div>
        </div>

        <Link to="/get-estimate" data-testid="about-estimate-btn" className="mt-16 inline-flex items-center gap-2 rounded-full bg-flame hover:bg-flame-hover text-white font-heading font-bold px-8 py-4 transition-colors">
          START YOUR BUILD <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
